<template>
  <div class="h-full grid grid-rows-[auto_auto_1fr] overflow-hidden">
    <!-- <ThreadsNav :show-center="false" show-back>
      <template #right>
        <button class="btn btn-primary btn-sm rounded" @click="show = true">
          {{ $t("Buttons.createNewGame") }}
        </button>
      </template>
    </ThreadsNav> -->
    <ThreadsNav :enable-switch-mate="false" :show-back="true">
      <template #right>
        <button class="btn btn-sm btn-primary rounded" @click="show = true">
          {{ $t("Buttons.createNewGame") }}
        </button>
      </template>
    </ThreadsNav>

    <VanTabs
      v-model:active="store.activeCreateTab"
      @change="changeStoryBookType"
    >
      <VanTab :name="2" :title="$t('story.draft')"></VanTab>
      <VanTab :name="1" :title="$t('story.published')"></VanTab>
    </VanTabs>

    <div class="w-full h-full flex flex-col overflow-y-auto">
      <div
        v-if="store.createCurrentList.length === 0"
        class="h-40 flex flex-col items-center justify-center"
      >
        <div class="text-2xl font-bold text-base-content/50">
          {{ $t("Message.noGamesYet") }}
        </div>
      </div>
      <div v-else class="p-4 gap-3">
        <ItemGalGameHome
          v-for="item in store.createCurrentList"
          :key="item"
          :game="store.gameMap[item]"
          mode="edit"
        />
      </div>
    </div>
  </div>

  <ModalCreateScript v-model:show="show" />
</template>

<script lang="ts" setup>
import { useGalGameHome } from "@/stores/galGameHome";
import { ref } from "vue";

const show = ref(false);

const store = useGalGameHome();

const changeStoryBookType = () => {
  console.log("changeStoryBookType");
};
</script>
